import { STATES } from '@sparrow-card/sparrow-card-constants';
import { type RootInputProps } from 'components/Input/RootInput/types';
import Select from 'components/Select';
import { STATE_INPUT_LENGTH } from './config';

type Props = Pick<
  RootInputProps,
  'name' | 'label' | 'required' | 'containerClassName' | 'required'
>;

const StateInput = (props: Props) => {
  const { name, label, containerClassName, required } = props;

  return (
    <Select
      name={name}
      label={label}
      options={STATES}
      searchable={true}
      maxLength={STATE_INPUT_LENGTH}
      containerClassName={containerClassName}
      required={required}
    />
  );
};

export default StateInput;
